import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState, useEffect, useContext } from "react";
import { Alert, Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { BasicContext } from "../../App";
import { postMethod } from "../../requests";

const DeleteUserPassModal = (props) => {
    const { t } = useTranslation();
    const { onClose, onProceed, pass } = props;
    const [loading, setLoading] = useState(true);
    const { checkServerData, setAlerts } = useContext(BasicContext);
    const [showAlert, setShowAlert] = useState({ anyAssignedClass: false, notCancelledPayments: false });
    const [blockForm, setBlockForm] = useState(false);

    const checkIfAnyAssignedClass = async () => {
        const res = await postMethod("/check-if-any-assigned-classes", { upID: pass.up_id });
        if (checkServerData(res)) {
            setShowAlert({ anyAssignedClass: res.data.anyAssignedClass, notCancelledPayments: res.data.notCancelledPayments });
        }
        setLoading(false);
    };

    const deletePassFromUser = async () => {
        const res = await postMethod("/delete-pass-from-user", { upID: pass.up_id, userID: pass.user_id, passName: pass.pass_name, passOrderNumber: pass.order_number });
        if (checkServerData(res)) {
            setAlerts([{ variant: "success", message: t(`success.${res.data.code}`), fading: 1500, id: "deletedpass" }]);
            onProceed();
        } else setBlockForm(false);
    };

    useEffect(() => {
        checkIfAnyAssignedClass();
        //console.log(pass);
        // eslint-disable-next-line
    }, []);

    return (
        <Modal show={true} onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>{t("deletePassModal.title")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {loading ? (
                    <p>{t("loadingData")}</p>
                ) : (
                    <>
                        {showAlert.anyAssignedClass && (
                            <Alert variant="warning" className="mb-3">
                                <FontAwesomeIcon icon={faExclamationTriangle} className="me-2" />
                                {t("warning.thereAreAssignedClassesToDeletingPass")}
                            </Alert>
                        )}
                        {showAlert.notCancelledPayments && (
                            <Alert variant="warning" className="mb-3">
                                <FontAwesomeIcon icon={faExclamationTriangle} className="me-2" />
                                {t("warning.thereAreNotCancelledPaymentsToThisPass")}
                            </Alert>
                        )}
                        {t("deletePassModal.text", { passName: pass.pass_name })}
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={onClose}>
                    {t("deletePassModal.cancelTxt")}
                </Button>
                <Button
                    disabled={loading || blockForm}
                    variant="outline-primary"
                    onClick={() => {
                        setBlockForm(true);
                        setAlerts([{ variant: "info", message: t("info.deletingPassFromUser") }]);
                        setTimeout(() => {
                            deletePassFromUser();
                        }, 300);
                    }}
                >
                    {t("deletePassModal.proceedTxt")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DeleteUserPassModal;
